import { render, staticRenderFns } from "./BusinessNumberPop.vue?vue&type=template&id=68c15b65&scoped=true"
import script from "./BusinessNumberPop.vue?vue&type=script&lang=js"
export * from "./BusinessNumberPop.vue?vue&type=script&lang=js"
import style0 from "./BusinessNumberPop.vue?vue&type=style&index=0&id=68c15b65&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c15b65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c15b65')) {
      api.createRecord('68c15b65', component.options)
    } else {
      api.reload('68c15b65', component.options)
    }
    module.hot.accept("./BusinessNumberPop.vue?vue&type=template&id=68c15b65&scoped=true", function () {
      api.rerender('68c15b65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/BusinessNumberPop.vue"
export default component.exports